import { h, render, Component } from 'preact';
import './marker.scss';

export default class Marker extends Component {

    _getImageStatusMarkup(status) {
        return { __html: fmtools.getStatusObjectIcon(status)}
    }

    render (props, state) {
        const wrapperProps = {
            class: props.active?"marker-item marker-item-active":"marker-item"
        };

        if (!props.disabled) {
            wrapperProps['onTouchTap'] = (e) => props.onTapMarker(props.marker,e);
        }
        return (
            <div {...wrapperProps} >
                <img src={`../icons/objects/${props.marker.obj_icon}`} class="marker-item-icon"/>
                <span class="marker-item-content">{props.marker.name}</span>
                <span class="marker-item-status">
                    <div dangerouslySetInnerHTML={this._getImageStatusMarkup(props.marker.move)} />
                </span>
            </div>
        );
    }
}